export const getFormattedDateMDY = (date: Date) => new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})
  .format(date);

type ErrorObject = {
  [key: string]: any;
};

export const handleErrorMessages = (
  error: any[] | ErrorObject,
  callback: (errorString: string
  ) => void,
) => {
  const errorMsg: string[] = [];

  const errorMessage = (err: any) => {
    if (Array.isArray(err)) {
      err.forEach((item) => {
        errorMessage(item);
      });
    } else if (typeof err === 'object' && err !== null) {
      Object.keys(err).forEach((item) => {
        errorMessage(err[item]);
      });
    } else if (typeof err === 'string') {
      errorMsg.push(err);
    }
  };

  errorMessage(error);

  if (errorMsg?.length > 0) {
    callback(errorMsg.join(', '));
  } else {
    callback('Something went wrong, please try again later.');
  }
};
